import Button from '../../Reusable/Button'
import { useForm } from 'react-hook-form';
import APIS from '../../../constant/EndPoint';
import ComboboxInput from '../../Reusable/Form/ComboboxInput';
import useGetHook from '../../../customHooks/useGetHook';
import TextField from '../../Reusable/Form/TextInput';
import { useSearchParams } from 'react-router-dom';



const ChangeStatus = ({ handleActionMenu, isLoading }: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors
  } = useForm<any>();

  const { data } = useGetHook({
    queryKey: [watch("status")],
    url: watch("status") ? `${APIS.STATUS}${watch("status")}/` : APIS.STATUS,
    params: {},
  });
  const [searchParams, setSearchParms] = useSearchParams()

  return (
    <form onSubmit={handleSubmit((data: any) =>
      handleActionMenu(data, "Change Status", setError)
    )} autoComplete="off">
      <div className='flex flex-col justify-between min-h-full'>
        <ComboboxInput
          url={APIS.STATUS_NEXT}
          queryKey={"status"}
          register={register("status" as const, {
            required: "Status is required",
          })}
          errors={errors?.status}
          name={"status"}
          label={""}
          setValue={setValue}
          placeholder={"Search Status"}
          getValues={getValues}
          props={
            { order_ids: searchParams.get("selectedItems") }
          }
          clearErrors={clearErrors}
        />
        {!Array.isArray(data) && data?.name === "Partial Delivered" ?
          <>
            <TextField
              label={"Collected COD"}
              register={register("collected_cod" as const, {
                required: "Collected COD is required",
              })}
              errors={errors?.collected_cod}
            />
            <TextField
              label={"Remark"}
              register={register("remark" as const, {
                required: "Remark is required",
              })}
              errors={errors?.remark}
            />
          </>

          : ""}
        <div className="w-[100px] mr-4 absolute bottom-4 right-2">
          <Button
            label={"Submit"}
            isLoading={isLoading}

          />
        </div>
      </div>
    </form>
  )
}

export default ChangeStatus
